import React from "react"
import styled from "styled-components"

import { Element, Text } from "legacy/components/shared/base"

export type CarouselControlsProps = {
  buttonAction: "previous" | "next"
  onButtonClick: () => void
}

const StyledElement = styled(Element)`
  &:hover span,
  &:focus span {
    color: #2e827c;
  }
`

export const ControlButton: React.FC<CarouselControlsProps> = ({
  buttonAction,
  onButtonClick,
}): React.ReactElement | null => {
  const isNextButton = buttonAction === "next"
  return (
    <StyledElement
      as="button"
      bg="cream"
      cursor="pointer"
      fontSize="16"
      lineHeight="56px"
      height="56px"
      marginLeft={isNextButton ? "xs" : "0"}
      onClick={onButtonClick}
      width="56px"
    >
      <Text as="span" color="white" fontSize="54" verticalAlign="middle">
        {buttonAction === "next" ? <>&rsaquo;</> : <>&lsaquo;</>}
      </Text>
    </StyledElement>
  )
}
